import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
	invoiceGenerationApiBaseUrl,
	irnGenerationApiBaseUrl,
} from '../../../util/envConfig';
import { generateInvoice, generateIrn } from '../url';

// Common headers for all requests
const commonHeaders = {
	'Content-Type': 'application/json',
};

const irnHeaders = {
	...commonHeaders,
	'x-logintenantcode': 'bighaat',
	'x-tenantcode': 'bighaat',
	'x-tenantid': 'bcaecd63-10ad-4c4b-839e-88e81965df5f',
};

export const invoiceApiSlice = createApi({
	reducerPath: 'invoiceApi',
	baseQuery: fetchBaseQuery({}),
	endpoints: (builder) => ({
		// IRN Generation endpoint
		generateIrn: builder.mutation({
			queryFn: async (payload, _queryApi, _extraOptions, fetchWithBQ) => {
				const irnQuery = fetchBaseQuery({
					baseUrl: irnGenerationApiBaseUrl,
					prepareHeaders: () => new Headers(irnHeaders),
				});

				try {
					const response = await irnQuery(
						{
							url: generateIrn,
							method: 'POST',
							body: payload,
						},
						_queryApi,
						_extraOptions
					);

					return { data: response.data };
				} catch (error) {
					return { error: { status: error.status, data: error.data } };
				}
			},
		}),

		// Invoice PDF Generation endpoint
		generateInvoicePdf: builder.mutation({
			queryFn: async (invoiceData, _queryApi, _extraOptions, fetchWithBQ) => {
				const invoicePdfQuery = fetchBaseQuery({
					baseUrl: invoiceGenerationApiBaseUrl,
					prepareHeaders: () => {
						const headers = new Headers(commonHeaders);
						return headers;
					},
				});

				try {
					const response = await invoicePdfQuery(
						{
							url: generateInvoice,
							method: 'POST',
							body: invoiceData,
							responseHandler: async (response) => {
								if (!response.ok) {
									const errorText = await response.text();
									console.error('PDF Generation - Response Error:', {
										status: response.status,
										statusText: response.statusText,
										error: errorText,
									});
									throw new Error(
										`Failed to generate invoice PDF: ${response.status} - ${errorText}`
									);
								}
								const blob = await response.blob();
								return blob;
							},
						},
						_queryApi,
						_extraOptions
					);

					return { data: response.data };
				} catch (error) {
					console.error('PDF Generation - Error:', {
						message: error.message,
						stack: error.stack,
					});

					return {
						error: {
							status: error.status || 500,
							data: error.message || 'Failed to generate PDF',
						},
					};
				}
			},
		}),
	}),
});

export const { useGenerateIrnMutation, useGenerateInvoicePdfMutation } =
	invoiceApiSlice;
